// import {parse} from 'date-fns'
export default class Session {
  constructor (id, name) {
    this.id = id
    this.name = name
    this.starts = null
    this.ends = null
  }
  static fromJson (json) {
    let session = new this(json.uuid, json.name)
    if (json.starts != null) {
      // session.starts = parse(json.starts, 'yyyy-MM-dd HH:mm:ss', new Date())
      session.starts = new Date(Date.parse(json.starts))
    }
    if (json.ends != null) {
      // session.ends = parse(json.ends, 'yyyy-MM-dd HH:mm:ss', new Date())
      session.ends = new Date(Date.parse(json.ends))
    }
    return session
  }

  isCurrent () {
    if (this.starts === null && this.ends === null) {
      return false
    }
    return this.starts.valueOf() <= new Date().valueOf() && this.ends.valueOf() >= new Date().valueOf()
  }

  isPast () {
    if (this.starts === null && this.ends === null) {
      return false
    }
    return this.ends.valueOf() <= new Date().valueOf()
  }

  isFuture () {
    if (this.starts === null && this.ends === null) {
      return false
    }
    return this.starts.valueOf() >= new Date().valueOf()
  }

  isToday () {
    const today = new Date()
    return this.starts.getFullYear() === today.getFullYear() &&
      this.starts.getMonth() === today.getMonth() &&
      this.starts.getDate() === today.getDate()
  }

  isBefore (session) {
    if (this.starts === null) {
      return false
    }
    if (this.ends === null) {
      return false
    }
    return this.starts < session.starts
  }
}



// WEBPACK FOOTER //
// ./src/models/session.js